/**
 * This middleware captures actions and  handle custom events
 */
import { goPopup } from 'Store/actions/portalModalActions';
import { flowPopupTypes } from 'Utility/flowPopupMap';

export const goPopupHandler = (isSuccess, titleId, buttons) =>
  goPopup('GENERIC_POPUP', {
    hasOutcome: true,
    outcome: isSuccess ? 'success' : 'failure',
    title: { id: titleId },
    buttons,
  });

const globals = (store) => (next) => (action) => {
	if (/_FAILURE|_SUCCESS/i.test(action.type)) {
		if (action.error && /_FAILURE/i.test(action.type)) {
      action.error.status === 401 ? store.dispatch(goPopupHandler(false, 't.global.unauth', [
      {
        contentText: { id: 't.global.login' },
        onClick: () => {window.sessionStorage.clear(); window.location.replace('/')}
      },
    ])) :
      store.dispatch(goPopup(flowPopupTypes.GENERIC_POPUP, {
      hasOutcome: true,
      outcome: 'failure',
      title: { id: 't.global.error' },
      buttons: [
      { contentText: { id: 't.global.close' }, },
      ]}))
		}
	}
	return next(action);
};

export default globals;
